export enum SignatureRequestStatusEnum {
    Draft = 1,
    Pending = 2,
    InProgress = 3,
    Completed = 4,
    Canceled = 5,
    Rejected = 6
}


export const statusTextMap: Record<SignatureRequestStatusEnum, string> = {
    [SignatureRequestStatusEnum.Draft]: 'Borrador',
    [SignatureRequestStatusEnum.Pending]: 'Pendiente',
    [SignatureRequestStatusEnum.InProgress]: 'En Progreso',
    [SignatureRequestStatusEnum.Completed]: 'Completado',
    [SignatureRequestStatusEnum.Canceled]: 'Cancelado',
    [SignatureRequestStatusEnum.Rejected]: 'Rechazado'
};


export enum SignatureParticipantStatusEnum{
    Draft = 1,
    Pending = 2,
    Rejected = 3,
    Completed = 4,
    Removed = 5,
    Canceled = 6
}

export const participantStatusTextMap: Record<SignatureParticipantStatusEnum, string> = {
    [SignatureParticipantStatusEnum.Draft]: 'Borrador',
    [SignatureParticipantStatusEnum.Pending]: 'Pendiente',
    [SignatureParticipantStatusEnum.Rejected]: 'Rechazado',
    [SignatureParticipantStatusEnum.Completed]: 'Completado',
    [SignatureParticipantStatusEnum.Removed]: 'Eliminado',
    [SignatureParticipantStatusEnum.Canceled]: 'Cancelado'
};

/**
 * Document status enumeration and its corresponding text map.
 */
export enum SignatureDocumentStatusEnum {
    Draft = 1,
    Pending = 2,
    InProgress = 3,
    Signed = 4,
    Rejected = 5,
    Canceled = 6
}

/**
 * Document status text map.
 */
export const documentStatusTextMap: Record<SignatureDocumentStatusEnum, string> = {
    [SignatureDocumentStatusEnum.Draft]: 'Borrador',
    [SignatureDocumentStatusEnum.Pending]: 'Pendiente',
    [SignatureDocumentStatusEnum.InProgress]: 'En Progreso',
    [SignatureDocumentStatusEnum.Signed]: 'Firmado',
    [SignatureDocumentStatusEnum.Rejected]: 'Rechazado',
    [SignatureDocumentStatusEnum.Canceled]: 'Cancelado'
};


export enum SignatureSignatoryAssignmentStatusEnum{
    Draft = 0,
    Pending = 1,
    Rejected = 3,
    Signed = 4,
    Removed = 5,
    Canceled = 6
}
export const signatoryAssignmentStatusTextMap: Record<SignatureSignatoryAssignmentStatusEnum, string> = {
    [SignatureSignatoryAssignmentStatusEnum.Draft]: 'Borrador',
    [SignatureSignatoryAssignmentStatusEnum.Pending]: 'Pendiente',
    [SignatureSignatoryAssignmentStatusEnum.Rejected]: 'Rechazado',
    [SignatureSignatoryAssignmentStatusEnum.Signed]: 'Firmado',
    [SignatureSignatoryAssignmentStatusEnum.Removed]: 'Eliminado',
    [SignatureSignatoryAssignmentStatusEnum.Canceled]: 'Cancelado'
};

export enum SignatureRequestTypeEnum{
    SimpleElectronicSignature = 1,
    AdvancedElectronicSignature = 2,
}

export const signatureRequestTypeTextMap: Record<SignatureRequestTypeEnum, string> = {
    [SignatureRequestTypeEnum.SimpleElectronicSignature]: 'Firma Electrónica Simple',
    [SignatureRequestTypeEnum.AdvancedElectronicSignature]: 'Firma Electrónica Avanzada'
};